<template>
    <div :class="{loading: loading.data}">
        <!-- Badge card start -->
        <template v-if="milestones.length">
            <milestone-card v-for="milestone in milestones" :milestone="milestone">
            </milestone-card>
        </template>
        <!-- Badge card end -->
        <div v-else class="dashboard-card mt-2">
            <div class="d-flex flex-column justify-content-center align-items-center" style="height: 300px">
                <span class="dashboard-card-title">There are no milestones yet</span>
                <span class="dashboard-card-description text-center" style="max-width: 360px">
                    First add Heroes and create your Support Team
                </span>
            </div>
        </div>
    </div>
</template>

<script>

import MilestoneCard from "@/components/MilestoneCard.vue";

export default {
    name: "MilestonesList",
    components: { MilestoneCard },
    data() {
        return {
            loading: {
                data: false,
            },
            milestones: {
                hero: {},
                achievement: {}
            }
        }
    },
    mounted() {
        this.getMilestones();
        this.$events.$on('loadMilestones', this.getMilestones);
    },
    methods: {
        getMilestones() {
            this.loading.data = true;
            const url = this.$route.params.hero_id ? "/hero/milestones" : "/dashboard/milestones"
            this.$http.post(url, {hero_id: this.$route.params.hero_id})
                .then((res) => {
                    this.milestones = res.body.data;
                    this.loading.data = false;
                })
                .catch((error) => {
                    this.loading.data = false;
                });
        },
    }
}
</script>

<style scoped>

</style>
